import ModalActions from '@components/modal/ModalActions';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { type FC } from 'react';

interface Props {
  isSubmitting: boolean;
  isDirty: boolean;
  factoryDefaultsHandler: () => void;
  resetHandler: () => void;
}

export const CustomModalActions: FC<Props> = ({
  isSubmitting,
  isDirty,
  resetHandler,
  factoryDefaultsHandler,
}) => {
  const { _ } = useLingui();

  return (
    <ModalActions
      dialogActionsProps={{
        sx: {
          mx: 0,
          p: 0,
        },
      }}
      submitLoading={isSubmitting}
      onSubmit="submit"
      dirtyForm={isDirty}
      customButtons={[
        {
          label: _(msg`Restablecer valores por defecto`),
          onClick: factoryDefaultsHandler,
          color: 'warning',
        },
      ]}
      rightButtons={[
        {
          label: _(msg`Restablecer formulario`),
          onClick: resetHandler,
          disabled: !isDirty,
        },
      ]}
    />
  );
};
